import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { logout } from "../../redux/modules/auth/actions";
import { userSelector } from "../../redux/modules/auth/userSelector";

export function NavbarToggler() {
  const dispatch = useDispatch<any>();
  const navigate = useNavigate();
  const user = useSelector(userSelector);

  const handleLogout = () => {
    dispatch(logout());
    navigate("/login");
  };

  return (
    <div className="d-flex align-items-center gap-2">
      {user && user.role === 'user' && (
        <div className="d-flex align-items-center">
          <span
            className="text-muted small mr-3"
            style={{ fontWeight: 500 }}
          >
            {user.firstName} {user.lastName}
          </span>
          <button
            type="button"
            className="btn btn-outline-secondary btn-sm"
            onClick={handleLogout}
            title="Logout"
          >
            <i className="fa fa-sign-out mr-1"></i>
            Logout
          </button>
        </div>
      )}
      <div className="toggler ml-2">
        <button
          className="btn nav-btn navbar-toggler d-block d-lg-none"
          type="button"
          onClick={() => {
            const navBar = document.querySelector(".vertical-nav");
            navBar?.classList.toggle("menuIn");
          }}
        >
          <span className="fa fa-bars"></span>
        </button>
      </div>
    </div>
  );
}
